import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ─── Common ───
import plCommon from '../locales/pl/common.json';
import enCommon from '../locales/en/common.json';
import deCommon from '../locales/de/common.json';
import frCommon from '../locales/fr/common.json';
import ukCommon from '../locales/uk/common.json';

// ─── Auth ───
import plAuth from '../locales/pl/auth.json';
import enAuth from '../locales/en/auth.json';
import deAuth from '../locales/de/auth.json';
import frAuth from '../locales/fr/auth.json';
import ukAuth from '../locales/uk/auth.json';

// ─── Documents ───
import plDocuments from '../locales/pl/documents.json';
import enDocuments from '../locales/en/documents.json';
import deDocuments from '../locales/de/documents.json';
import frDocuments from '../locales/fr/documents.json';
import ukDocuments from '../locales/uk/documents.json';

// ─── Dashboard ───
import plDashboard from '../locales/pl/dashboard.json';
import enDashboard from '../locales/en/dashboard.json';
import deDashboard from '../locales/de/dashboard.json';
import frDashboard from '../locales/fr/dashboard.json';
import ukDashboard from '../locales/uk/dashboard.json';

// ─── Studio ───
import plStudio from '../locales/pl/studio.json';
import enStudio from '../locales/en/studio.json';
import deStudio from '../locales/de/studio.json';
import frStudio from '../locales/fr/studio.json';
import ukStudio from '../locales/uk/studio.json';

// ─── Settings ───
import plSettings from '../locales/pl/settings.json';
import enSettings from '../locales/en/settings.json';
import deSettings from '../locales/de/settings.json';
import frSettings from '../locales/fr/settings.json';
import ukSettings from '../locales/uk/settings.json';

// ─── Legal Search ───
import plLegal from '../locales/pl/legal.json';
import enLegal from '../locales/en/legal.json';
import deLegal from '../locales/de/legal.json';
import frLegal from '../locales/fr/legal.json';
import ukLegal from '../locales/uk/legal.json';

// ─── Creator ───
import plCreator from '../locales/pl/creator.json';
import enCreator from '../locales/en/creator.json';
import deCreator from '../locales/de/creator.json';
import frCreator from '../locales/fr/creator.json';
import ukCreator from '../locales/uk/creator.json';

// ─── Admin ───
import plAdmin from '../locales/pl/admin.json';
import enAdmin from '../locales/en/admin.json';
import deAdmin from '../locales/de/admin.json';
import frAdmin from '../locales/fr/admin.json';
import ukAdmin from '../locales/uk/admin.json';

// ─── Negotiation ───
import plNegotiation from '../locales/pl/negotiation.json';
import enNegotiation from '../locales/en/negotiation.json';
import deNegotiation from '../locales/de/negotiation.json';
import frNegotiation from '../locales/fr/negotiation.json';
import ukNegotiation from '../locales/uk/negotiation.json';

// ─── Templates ───
import plTemplates from '../locales/pl/templates.json';
import enTemplates from '../locales/en/templates.json';
import deTemplates from '../locales/de/templates.json';
import frTemplates from '../locales/fr/templates.json';
import ukTemplates from '../locales/uk/templates.json';

// ─── Court Portal ───
import plCourtportal from '../locales/pl/courtportal.json';
import enCourtportal from '../locales/en/courtportal.json';
import deCourtportal from '../locales/de/courtportal.json';
import frCourtportal from '../locales/fr/courtportal.json';
import ukCourtportal from '../locales/uk/courtportal.json';

// ─── Landing ───
import plLanding from '../locales/pl/landing.json';
import enLanding from '../locales/en/landing.json';
import deLanding from '../locales/de/landing.json';
import frLanding from '../locales/fr/landing.json';
import ukLanding from '../locales/uk/landing.json';

// ─── Contracts ───
import plContracts from '../locales/pl/contracts.json';
import enContracts from '../locales/en/contracts.json';
import deContracts from '../locales/de/contracts.json';
import frContracts from '../locales/fr/contracts.json';
import ukContracts from '../locales/uk/contracts.json';

// ─── Prediction ───
import plPrediction from '../locales/pl/prediction.json';
import enPrediction from '../locales/en/prediction.json';
import dePrediction from '../locales/de/prediction.json';
import frPrediction from '../locales/fr/prediction.json';
import ukPrediction from '../locales/uk/prediction.json';

// ─── Calculators ───
import plCalculators from '../locales/pl/calculators.json';
import enCalculators from '../locales/en/calculators.json';
import deCalculators from '../locales/de/calculators.json';
import frCalculators from '../locales/fr/calculators.json';
import ukCalculators from '../locales/uk/calculators.json';

// ─── Analytics ───
import plAnalytics from '../locales/pl/analytics.json';
import enAnalytics from '../locales/en/analytics.json';
import deAnalytics from '../locales/de/analytics.json';
import frAnalytics from '../locales/fr/analytics.json';
import ukAnalytics from '../locales/uk/analytics.json';

// ─── Trash ───
import plTrash from '../locales/pl/trash.json';
import enTrash from '../locales/en/trash.json';
import deTrash from '../locales/de/trash.json';
import frTrash from '../locales/fr/trash.json';
import ukTrash from '../locales/uk/trash.json';

// ─── Pricing ───
import plPricing from '../locales/pl/pricing.json';
import enPricing from '../locales/en/pricing.json';
import dePricing from '../locales/de/pricing.json';
import frPricing from '../locales/fr/pricing.json';
import ukPricing from '../locales/uk/pricing.json';

// ─── History ───
import plHistory from '../locales/pl/history.json';
import enHistory from '../locales/en/history.json';
import deHistory from '../locales/de/history.json';
import frHistory from '../locales/fr/history.json';
import ukHistory from '../locales/uk/history.json';

// ─── Agent ───
import plAgent from '../locales/pl/agent.json';
import enAgent from '../locales/en/agent.json';
import deAgent from '../locales/de/agent.json';
import frAgent from '../locales/fr/agent.json';
import ukAgent from '../locales/uk/agent.json';

// ─── User Inbox ───
import plUserinbox from '../locales/pl/userinbox.json';
import enUserinbox from '../locales/en/userinbox.json';
import deUserinbox from '../locales/de/userinbox.json';
import frUserinbox from '../locales/fr/userinbox.json';
import ukUserinbox from '../locales/uk/userinbox.json';

// ─── Admin Inbox ───
import plAdmininbox from '../locales/pl/admininbox.json';
import enAdmininbox from '../locales/en/admininbox.json';
import deAdmininbox from '../locales/de/admininbox.json';
import frAdmininbox from '../locales/fr/admininbox.json';
import ukAdmininbox from '../locales/uk/admininbox.json';

// ─── Due Diligence ───
import plDuediligence from '../locales/pl/duediligence.json';
import enDuediligence from '../locales/en/duediligence.json';
import deDuediligence from '../locales/de/duediligence.json';
import frDuediligence from '../locales/fr/duediligence.json';
import ukDuediligence from '../locales/uk/duediligence.json';

// ─── Knowledge Base ───
import plKnowledge from '../locales/pl/knowledge.json';
import enKnowledge from '../locales/en/knowledge.json';
import deKnowledge from '../locales/de/knowledge.json';
import frKnowledge from '../locales/fr/knowledge.json';
import ukKnowledge from '../locales/uk/knowledge.json';

// ─── Knowledge Graph ───
import plKnowledgegraph from '../locales/pl/knowledgegraph.json';
import enKnowledgegraph from '../locales/en/knowledgegraph.json';
import deKnowledgegraph from '../locales/de/knowledgegraph.json';
import frKnowledgegraph from '../locales/fr/knowledgegraph.json';
import ukKnowledgegraph from '../locales/uk/knowledgegraph.json';

// ─── PDF Lab ───
import plPdflab from '../locales/pl/pdflab.json';
import enPdflab from '../locales/en/pdflab.json';
import dePdflab from '../locales/de/pdflab.json';
import frPdflab from '../locales/fr/pdflab.json';
import ukPdflab from '../locales/uk/pdflab.json';

// ─── Compliance ───
import plCompliance from '../locales/pl/compliance.json';
import enCompliance from '../locales/en/compliance.json';
import deCompliance from '../locales/de/compliance.json';
import frCompliance from '../locales/fr/compliance.json';
import ukCompliance from '../locales/uk/compliance.json';

// ─── Benchmark ───
import plBenchmark from '../locales/pl/benchmark.json';
import enBenchmark from '../locales/en/benchmark.json';
import deBenchmark from '../locales/de/benchmark.json';
import frBenchmark from '../locales/fr/benchmark.json';
import ukBenchmark from '../locales/uk/benchmark.json';

// ─── Developer ───
import plDeveloper from '../locales/pl/developer.json';
import enDeveloper from '../locales/en/developer.json';
import deDeveloper from '../locales/de/developer.json';
import frDeveloper from '../locales/fr/developer.json';
import ukDeveloper from '../locales/uk/developer.json';

// ─── Sources ───
import plSources from '../locales/pl/sources.json';
import enSources from '../locales/en/sources.json';
import deSources from '../locales/de/sources.json';
import frSources from '../locales/fr/sources.json';
import ukSources from '../locales/uk/sources.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'pl', name: 'Polski', flag: '\u{1F1F5}\u{1F1F1}' },
  { code: 'en', name: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'de', name: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'fr', name: 'Fran\u00e7ais', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'uk', name: '\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430', flag: '\u{1F1FA}\u{1F1E6}' },
];

const ALL_NS = [
  'common', 'auth', 'documents', 'dashboard', 'studio', 'settings',
  'legal', 'creator', 'admin', 'negotiation', 'templates', 'courtportal',
  'landing', 'contracts', 'prediction', 'calculators', 'analytics', 'trash', 'pricing',
  'history', 'agent', 'userinbox', 'admininbox', 'duediligence',
  'knowledge', 'knowledgegraph', 'pdflab', 'compliance', 'benchmark',
  'developer', 'sources',
];

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        common: plCommon, auth: plAuth, documents: plDocuments, dashboard: plDashboard,
        studio: plStudio, settings: plSettings, legal: plLegal, creator: plCreator,
        admin: plAdmin, negotiation: plNegotiation, templates: plTemplates,
        courtportal: plCourtportal, landing: plLanding, contracts: plContracts,
        prediction: plPrediction, calculators: plCalculators, analytics: plAnalytics,
        trash: plTrash, pricing: plPricing, history: plHistory, agent: plAgent,
        userinbox: plUserinbox, admininbox: plAdmininbox, duediligence: plDuediligence,
        knowledge: plKnowledge, knowledgegraph: plKnowledgegraph, pdflab: plPdflab,
        compliance: plCompliance, benchmark: plBenchmark, developer: plDeveloper,
        sources: plSources,
      },
      en: {
        common: enCommon, auth: enAuth, documents: enDocuments, dashboard: enDashboard,
        studio: enStudio, settings: enSettings, legal: enLegal, creator: enCreator,
        admin: enAdmin, negotiation: enNegotiation, templates: enTemplates,
        courtportal: enCourtportal, landing: enLanding, contracts: enContracts,
        prediction: enPrediction, calculators: enCalculators, analytics: enAnalytics,
        trash: enTrash, pricing: enPricing, history: enHistory, agent: enAgent,
        userinbox: enUserinbox, admininbox: enAdmininbox, duediligence: enDuediligence,
        knowledge: enKnowledge, knowledgegraph: enKnowledgegraph, pdflab: enPdflab,
        compliance: enCompliance, benchmark: enBenchmark, developer: enDeveloper,
        sources: enSources,
      },
      de: {
        common: deCommon, auth: deAuth, documents: deDocuments, dashboard: deDashboard,
        studio: deStudio, settings: deSettings, legal: deLegal, creator: deCreator,
        admin: deAdmin, negotiation: deNegotiation, templates: deTemplates,
        courtportal: deCourtportal, landing: deLanding, contracts: deContracts,
        prediction: dePrediction, calculators: deCalculators, analytics: deAnalytics,
        trash: deTrash, pricing: dePricing, history: deHistory, agent: deAgent,
        userinbox: deUserinbox, admininbox: deAdmininbox, duediligence: deDuediligence,
        knowledge: deKnowledge, knowledgegraph: deKnowledgegraph, pdflab: dePdflab,
        compliance: deCompliance, benchmark: deBenchmark, developer: deDeveloper,
        sources: deSources,
      },
      fr: {
        common: frCommon, auth: frAuth, documents: frDocuments, dashboard: frDashboard,
        studio: frStudio, settings: frSettings, legal: frLegal, creator: frCreator,
        admin: frAdmin, negotiation: frNegotiation, templates: frTemplates,
        courtportal: frCourtportal, landing: frLanding, contracts: frContracts,
        prediction: frPrediction, calculators: frCalculators, analytics: frAnalytics,
        trash: frTrash, pricing: frPricing, history: frHistory, agent: frAgent,
        userinbox: frUserinbox, admininbox: frAdmininbox, duediligence: frDuediligence,
        knowledge: frKnowledge, knowledgegraph: frKnowledgegraph, pdflab: frPdflab,
        compliance: frCompliance, benchmark: frBenchmark, developer: frDeveloper,
        sources: frSources,
      },
      uk: {
        common: ukCommon, auth: ukAuth, documents: ukDocuments, dashboard: ukDashboard,
        studio: ukStudio, settings: ukSettings, legal: ukLegal, creator: ukCreator,
        admin: ukAdmin, negotiation: ukNegotiation, templates: ukTemplates,
        courtportal: ukCourtportal, landing: ukLanding, contracts: ukContracts,
        prediction: ukPrediction, calculators: ukCalculators, analytics: ukAnalytics,
        trash: ukTrash, pricing: ukPricing, history: ukHistory, agent: ukAgent,
        userinbox: ukUserinbox, admininbox: ukAdmininbox, duediligence: ukDuediligence,
        knowledge: ukKnowledge, knowledgegraph: ukKnowledgegraph, pdflab: ukPdflab,
        compliance: ukCompliance, benchmark: ukBenchmark, developer: ukDeveloper,
        sources: ukSources,
      },
    },
    lng: localStorage.getItem('language') || 'pl',
    fallbackLng: 'pl',
    ns: ALL_NS,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false, // avoid Suspense wrapper requirement
    },
  });

export default i18n;
